import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when sitter clicks on the "Promote your profile" button on the Sitter Profile page
 *
 * &nbsp;
 */
export class SitterProfileClickShareYourProfile extends AnalyticsEvent {
  eventName = 'sitter-profile-click-share-your-profile';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.marketing.referrals;
}
